/***************************************************************
7/19/2017
Alexander Self
Profile Edit form
- Edits user profiles
***************************************************************/
import { TextInput, Select, AutoComplete, PasswordInput } from '../../inputs';
import { PROFILE_LOCATIONS, TYPES, LEVELS, GRADES, SUBGRADES, EMPLOYEE_STATUS } from '../../../constants';
import { onDummyComplete, mapEmployeeForAutoComplete, packageDashForm } from '../../../utils';
import React, { Component } from 'react';


class ProfileEditForm extends Component {
  render() {
    return (
      <div>
        <form id={'profile-edit-form'} onSubmit={(e) => e.preventDefault() } encType="multipart/form-data">
          <div className="row">
            <div className="col s12 m12 l3">
              <TextInput id={'edit-profile-firstName'} label={'First Name'} />
            </div>
            <div className="col s12 m12 l3">
              <TextInput id={'edit-profile-lastName'} label={'Last Name'} />
            </div>
            <div className="col s12 m12 l3">
              <TextInput id={'edit-profile-middleInit'} label={'Middle Initial'} />
            </div>
            <div className="col s12 m12 l3">
              <TextInput id={'edit-profile-eid'} label={'Employee ID'} />
            </div>
          </div>
          <div className="row">
            <div className="col s12 m12 l3 xl3">
              <div>
                <label>Position Type</label>
                <select id={'edit-profile-positionType'} className="browser-default">
                  <option value=""></option>
                  {
                    this.props.positionTypes.map((p) => (
                      <option key={p.positionType} value={p.positionType}>{p.positionType}</option>
                    ))
                  }
                </select>
              </div>
            </div>
            <div className="col s12 m12 l3 xl3">
              <TextInput id={'edit-profile-positionTitle'} label={'Position Title'} />
            </div>
            <div className="col s12 m12 l3 xl3">
              <Select id={'edit-profile-location'} label={'Location'} opts={PROFILE_LOCATIONS} />
            </div>
            <div className="col s12 m12 l3 xl3">
              <p className="trainer"><input type="checkbox" id={'edit-profile-partTime'} />
              <label htmlFor="edit-profile-partTime">Part-time</label></p>
            </div>
          </div>
          <div className="row">
            <div className="col s12 m12 l3">
              <Select id={'edit-profile-type'} label={'Type'} opts={TYPES} />
            </div>
            <div className="col s12 m12 l3">
              <TextInput id={'edit-profile-department'} label={'Department'} />
            </div>
            <div className="col s12 m12 l3">
              <TextInput id={'edit-profile-email'} label={'Email'} />
            </div>
            <div className="col s12 m12 l3">
              <TextInput id={'edit-profile-phone'} label={'Phone'} />
            </div>
          </div>
          <div className="row">
            <div className="col s12 m12 l3">
              <Select id={'edit-profile-grade'} label={'Employee Grade'} opts={GRADES} />
            </div>
            <div className="col s12 m12 l3">
              <Select id={'edit-profile-subgrade'} label={'Employee Subgrade'} opts={SUBGRADES} />
            </div>
            <div className="col s12 m12 l3">
              <Select id={'edit-profile-employeeStatus'} label={'Employee Status'} opts={EMPLOYEE_STATUS} />
            </div>
            <div className="col s12 m12 l3">
              <AutoComplete id={'edit-profile-managerId'} label={'Manager'}
                data={mapEmployeeForAutoComplete(this.props.employees)} onComplete={onDummyComplete} />
            </div>
          </div>
          <div className="row">
            <div className="col s12 m12 l12">
              <button className="btn btn-large waves-effect waves-light blue" type="submit"
                onClick={() => this.props.submitProfileToEdit(packageDashForm('profile-edit-form'), this.props.employees, this.props.employee)}>
                Submit
              </button>
            </div>
          </div>
        </form>
        <hr />
        <p className="flow-text">Login Form</p>
        <form id={'profile-editAuth-form'} onSubmit={(e) => e.preventDefault() }>
          <div className="row">
            <div className="col s12 m12 l4">
              <TextInput id={'edit-login-email'} label={'Email'} />
            </div>
            <div className="col s12 m12 l4">
              <TextInput id={'edit-login-eid'} label={'Employee ID'} />
            </div>
            <div className="col s12 m12 l4">
              <Select id={'edit-login-level'} label={'Employee Access Level'} opts={LEVELS} />
            </div>
            <div className="col s12 m12 l6">
              <PasswordInput id={'edit-login-password'} label={'Password'} />
            </div>
            <div className="col s12 m12 l6">
              <PasswordInput id={'edit-login-passwordVerify'} label={'Password Verify'} />
            </div>
          </div>
          <div className="row">
            <div className="col s12 m12 l12">
              <button className="btn btn-large waves-effect waves-light blue" type="submit"
                onClick={() => this.props.submitLoginToEdit(packageDashForm('profile-editAuth-form'), this.props.employee)}>
                Submit
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default ProfileEditForm;



/* END */



// WEBPACK FOOTER //
// ./src/components/profiles/edit/profile_edit_form.js